import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { useForm } from 'react-hook-form';

import { REVALIDATE_MODES } from '@savgroup-front-common/constants';

import {
  DateRubric,
  DefaultRubric,
  Filters,
  RangeNumericRubric,
} from '../Datatable.types';

import { createFiltersRangeSchema } from './FiltersRange/FiltersRange.schema';

export const useDatatableFilters = ({
  filters,
  selectedFilters,
  onFilterClear,
}: {
  filters?: Filters;
  selectedFilters?: {
    filtersState?: DefaultRubric[];
    numericFiltersState?: RangeNumericRubric[];
    dateFiltersState?: DateRubric[];
  };
  onFilterClear?: () => void;
}) => {
  const [isOpen, setOpen] = useState(false);

  const buildDefaultFilters = () => {
    const defaultFilters: any = {};

    selectedFilters?.dateFiltersState?.forEach((dateFilter) => {
      const { filterName } = dateFilter;

      if (!filterName) {
        return;
      }
      if (
        filterName.startsWith('filterStartDate_') ||
        filterName.startsWith('filterEndDate_')
      ) {
        defaultFilters[`filterStartDate_${dateFilter.name}`] =
          dateFilter.minValue;
        defaultFilters[`filterEndDate_${dateFilter.name}`] =
          dateFilter.maxValue;
      }
    });
    selectedFilters?.filtersState?.forEach((filter) => {
      const { filterName } = filter;

      if (!filterName) {
        return;
      }
      defaultFilters[filterName] = filter.facets.map((facet) => ({
        value: facet.name || '',
        label: `${facet.name} - ( ${facet.count} )`,
        data: facet,
      }));
    });
    selectedFilters?.numericFiltersState?.forEach((numericFilter) => {
      const { filterName } = numericFilter;

      if (!filterName) {
        return;
      }
      if (
        filterName.startsWith('filterStartRangeNumeric_') ||
        filterName.startsWith('filterEndRangeNumeric_')
      ) {
        defaultFilters[`filterStartRangeNumeric_${numericFilter.name}`] =
          numericFilter.minValue;
        defaultFilters[`filterEndRangeNumeric_${numericFilter.name}`] =
          numericFilter.maxValue;
      }
    });

    return defaultFilters;
  };

  const formContext = useForm({
    defaultValues: buildDefaultFilters(),
    resolver: yupResolver(createFiltersRangeSchema(filters)),
    mode: REVALIDATE_MODES.ON_CHANGE,
  });

  const handleResetFilters = () => {
    if (onFilterClear) {
      onFilterClear();
    }
    Object.keys(formContext.getValues()).map((filterKey) =>
      filterKey.indexOf('filterDefault') >= 0
        ? formContext.setValue(filterKey, [])
        : formContext.setValue(filterKey, undefined),
    );
  };

  return {
    isOpen,
    setOpen,
    formContext,
    selectedFiltersNumber:
      (selectedFilters?.filtersState?.length || 0) +
      (selectedFilters?.numericFiltersState?.length || 0) +
      (selectedFilters?.dateFiltersState?.filter(
        (dateFilter) => dateFilter !== null,
      ).length || 0),
    handleResetFilters,
  };
};
